import {
  getLocationSuggestions as _getLocationSuggestions,
  GetLocationSuggestionsPayload,
} from '@griply/services';
import { LocationSuggestion } from '@griply/types';
import { httpsCallable } from 'firebase/functions';
import { getErrorReporter } from 'shared/services/error-tracking';

import { getFunctions } from './helpers';

export const getLocationSuggestions = async (
  payload: GetLocationSuggestionsPayload,
): Promise<LocationSuggestion[]> => {
  try {
    return await _getLocationSuggestions({
      functions: getFunctions(),
      httpsCallable,
      payload,
    });
  } catch (error: unknown) {
    getErrorReporter().captureException(error, {
      tags: { source: 'locations-autocomplete' },
    });
    throw error;
  }
};
